import { createContext, useContext } from 'react';

export type ContractContextType = {
  contractData;
  lineItemsData;
  hasUnpausedCampaigns: boolean;
  isRefetching: boolean;
  refetch: Function;
  onToggleAdGroupPauseCallback: Function;
  setOnToggleAdGroupPauseCallback: Function;
  mainBodyWidth: number;
  contractName: string;
  setContractName: Function;
};

export const ContractConfigurationContext = createContext<ContractContextType | undefined>(undefined);

export const useContractConfigurationContext = (): ContractContextType => useContext(ContractConfigurationContext);
